import { palette } from 'cds/styles';
import { FC } from 'react';
import styled from 'styled-components';

const Section9: FC = () => {
  return (
    <L_Section9>
      <span>기업과 임직원의 목적과 방향성에 맞춰</span>
      <br />
      <span>서비스를 제공합니다.</span>
      <ImageContainer>
        <img src="/new/biz/logos/후기1.png" alt="후기1" />
        <img src="/new/biz/logos/후기2.png" alt="후기2" />
        <img src="/new/biz/logos/후기3.png" alt="후기3" />
        <img src="/new/biz/logos/후기4.png" alt="후기4" />
        <img src="/new/biz/logos/후기5.png" alt="후기5" />
      </ImageContainer>
    </L_Section9>
  );
};
const L_Section9 = styled.section`
  margin: 0 auto;
  background-color: ${palette.BTN.BG};
  padding-top: 10rem;
  padding: 10rem 2rem 0 2rem;
  text-align: center;
  & > span {
    font-weight: 600;
    font-size: 2.4rem;
    color: ${palette.grey75};
  }
`;
const ImageContainer = styled.div`
  padding: 6rem 2rem 6rem 2rem;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  column-gap: 4rem;
  & > img {
    width: 28rem;
    margin-top: 2rem;
  }
  margin: 0 -2rem 0 -2rem;

  /* 280 * 5 : 이미지 너비 * 이미지 개수 */
  /* 40 * 4 : 이미지 간격 * 간격수 */
  /* 40 * 2 : 양 옆 패딩 */

  @media (min-width: 1640px) {
    justify-content: center;
    padding: 6rem 2rem 6rem 2rem;
    margin: 0 auto;
  }
`;

export default Section9;
